import { type CSSProperties } from 'react';

/**
 * @internal
 * Calculates the breakpoint for the container based on the width of the container
 * and will return a breakpoint that is currently applied.
 * @returns A value of the current breakpoint currently applicable for the container, i.e. 'small'
 */
export function calculateBreakpointFromContainerSize(
  /** ContainerSize object with width and height properties. */
  containerSize: {
    width: number;
    height: number;
  },
): CSSProperties {
  return containerSize.width < 768
    ? {
        width: '100vw',
      }
    : {};
}
